import { Routes } from "@angular/router";
import { IndexPageComponent } from "./pages/index-page.component";
import { AuthPageComponent } from "./pages/auth-page.component";
import { SelfAssessmentPageComponent } from "./pages/self-assessment-page.component";
import { IslandPageComponent } from "./pages/island-page.component";
import { SettingsPageComponent } from "./pages/settings-page.component";
import { AchievementsPageComponent } from "./pages/achievements-page.component";
import { CrewPageComponent } from "./pages/crew-page.component";
import { RulesPageComponent } from "./pages/rules-page.component";
import { TutorialPageComponent } from "./pages/tutorial-page.component";
import { AdminIslandsPageComponent } from "./pages/admin-islands-page.component";
import { WinnerPageComponent } from "./pages/winner-page.component";
import { NotFoundPageComponent } from "./pages/not-found-page.component";

export const routes: Routes = [
  { path: "", component: IndexPageComponent },
  { path: "auth", component: AuthPageComponent },
  { path: "tutorial", component: TutorialPageComponent },
  { path: "crew", component: CrewPageComponent },
  { path: "achievements", component: AchievementsPageComponent },
  { path: "rules", component: RulesPageComponent },
  { path: "settings", component: SettingsPageComponent },
  { path: "island/:slug", component: IslandPageComponent },
  { path: "self-assessment", component: SelfAssessmentPageComponent },
  { path: "winner", component: WinnerPageComponent },
  { path: "admin/islands", component: AdminIslandsPageComponent },
  { path: "**", component: NotFoundPageComponent },
];
